import React from "react";
import { Layout, Security } from "../../components";
const SecurityPage = () => {
  return (
    <Layout>
      <Security />
    </Layout>
  );
};

export default SecurityPage;
